import { useEffect, useRef } from 'react';
import {
  SiteHeader, Hero, About, EducationalContents, Demo, Pedagogy, Schools, Trust,
  Pricing, Contact, SiteFooter, SoonToast, WhatsAppButton, ScrollNext,
} from './sections';
import { initKhotoua } from './khotoua';
import './khotoua.css';

const TITLE = 'خطوة Khotoua | تطبيق تعليمي وألعاب تعليمية للأطفال في تونس (5–12 سنة)';

// The home page is Arabic only (no language switching), exactly like the design.
const Home = () => {
  const root = useRef<HTMLDivElement>(null);

  useEffect(() => {
    document.title = TITLE;
    document.documentElement.lang = 'ar';
    document.documentElement.dir = 'rtl';
    // The browser looks for #section before React has rendered it
    const target = window.location.hash && document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
    if (target) target.scrollIntoView({ behavior: 'instant' as ScrollBehavior });
    return initKhotoua(root.current!);
  }, []);

  return (
    <div ref={root} className="kh-root" dir="rtl" style={{ fontFamily: "'IBM Plex Sans Arabic', Tahoma, sans-serif", color: "#121A4A", background: "#F3F5FF", overflowX: "clip" }}>
      <SiteHeader />
      <Hero />
      <About />
      <EducationalContents />
      <Demo />
      <Pedagogy />
      <Schools />
      <Trust />
      <Pricing />
      <Contact />
      <SiteFooter />
      <SoonToast />
      <WhatsAppButton />
      <ScrollNext />
    </div>
  );
};

export default Home;
